<template>
    <section class="tw:p-6">
        <div v-if="viewMode === 'region' && place.tipo_proceso_taquilla !== 2">
            <div class="tw:bg-gradient-to-r tw:from-blue-600 tw:to-blue-800 tw:rounded-lg tw:px-4 tw:py-3 tw:flex tw:items-center tw:justify-between">
                <h3 class="tw:text-white tw:text-lg tw:font-semibold tw:m-0">Seleccionar la región:</h3>
                <router-link
                    :to="{ name: 'back.abonos.listado-bloqueos' }"
                    class="tw:bg-white tw:text-blue-700 tw:px-4 tw:py-2 tw:rounded-lg tw:text-sm tw:font-medium tw:hover:bg-gray-100 tw:no-underline"
                >
                    Listado de bloqueos
                </router-link>
            </div>
            <div v-if="!loading" class="tw:text-center tw:mt-4">
                <CleSvgComponent
                    v-if="zonas.length > 0"
                    :zonas="zonas"
                    :place="place"
                    @clickZona="irAZona"
                />
            </div>
            <LoadingSpinner v-else class="tw:mt-4" />
        </div>

        <div v-if="viewMode === 'seccion'">
            <div class="tw:bg-gradient-to-r tw:from-blue-600 tw:to-blue-800 tw:rounded-lg tw:px-4 tw:py-3 tw:flex tw:items-center tw:justify-between">
                <h3 class="tw:text-white tw:text-lg tw:font-semibold tw:m-0">
                    {{ seccion_seleccionada ? seccion_seleccionada.name : 'Seleccionar la sección:' }}
                </h3>
                <div class="tw:flex tw:gap-2">
                    <Button v-if="breadcrumbs.length > 1" @click="volverSeccion">
                        Volver
                    </Button>
                    <router-link
                        :to="{ name: 'back.abonos.listado-bloqueos' }"
                        class="tw:bg-white tw:text-blue-700 tw:px-4 tw:py-2 tw:rounded-lg tw:text-sm tw:font-medium tw:hover:bg-gray-100 tw:no-underline"
                    >
                        Listado de bloqueos
                    </router-link>
                </div>
            </div>
            <div v-if="breadcrumbs.length > 1" class="tw:pb-3 tw:mt-4">
                <BreadcrumbNav :items="breadcrumbs" @navigate="irABreadcrumb" />
            </div>
            <div v-if="!seccion_seleccionada || seccion_seleccionada.tiene_secciones" class="tw:text-center">
                <SvgSectionsComponent
                    :secciones="secciones"
                    @clickZona="seleccionarSeccion"
                />
            </div>
            <div v-if="seccion_seleccionada && !seccion_seleccionada.tiene_secciones" class="tw:text-center">
                <SvgSectionComponent
                    :zonas="zonas"
                    :seccion="seccion_seleccionada"
                    @clickZona="seleccionarZonaFinal"
                />
            </div>
            <LoadingSpinner v-if="cargando_zonas" />
        </div>

        <div v-if="viewMode === 'butacas'">
            <div class="tw:bg-gradient-to-r tw:from-blue-600 tw:to-blue-800 tw:rounded-lg tw:px-4 tw:py-3 tw:flex tw:items-center tw:justify-between">
                <div>
                    <h2 class="tw:text-white tw:text-lg tw:font-semibold tw:m-0">Región: {{ zona.name }}</h2>
                    <h3 class="tw:text-blue-100 tw:text-sm tw:font-medium tw:m-0 tw:mt-1">Seleccionar butacas:</h3>
                </div>
                <div class="tw:flex tw:gap-2">
                    <Button v-if="place.tipo_proceso_taquilla !== 2" type="button" @click="volver">
                        Cambiar región
                    </Button>
                    <Button v-if="place.tipo_proceso_taquilla === 2" type="button" @click="volverSeccion">
                        Volver
                    </Button>
                </div>
            </div>
            <div class="tw:mt-4">
                <BloquearAsientosNormales
                    v-if="zona && !zona.tiene_plazas"
                    :zona_seleccionada="zona"
                />
                <BloquearPlazasRegionAnexa
                    v-if="zona && zona.tiene_plazas"
                    :zona="zona"
                />
            </div>
        </div>
    </section>
</template>

<script setup>
    import { ref, computed, onMounted, getCurrentInstance } from 'vue'
    import store from '@/store'
    import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent'
    import SvgSectionsComponent from '@/components/backend/stepper/abonos/components/secciones/components/SvgSectionsComponent.vue'
    import SvgSectionComponent from '@/components/backend/stepper/abonos/components/secciones/components/SvgSectionComponent.vue'
    import BloquearAsientosNormales from '@/components/backend/abonos/bloquear-asientos/BloquearAsientosNormales.vue'
    import BloquearPlazasRegionAnexa from '@/modules/admin/abonos/bloqueo-asientos/components/BloquearPlazasRegionAnexa.vue'
    import BreadcrumbNav from '@/modules/admin/ui/BreadcrumbNav.vue'
    import LoadingSpinner from '@/modules/admin/ui/LoadingSpinner.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const instance = getCurrentInstance()
    const config = instance?.proxy?.config ?? store.getters.getConfig

    const viewMode = ref('region')
    const loading = ref(true)
    const zonas = ref([])
    const zona = ref(null)
    const secciones = ref([])
    const seccion_seleccionada = ref(null)
    const breadcrumbs = ref([{ name: 'Inicio' }])
    const cargando_zonas = ref(false)

    const place = computed(() => store.getters.getRecinto)

    const listaId = computed(() => store.getters.getListaId)

    function getZonas(place_id) {
        loading.value = true
        const params = {
            filters: {
                place_id: place_id
            }
        }
        store.dispatch(config.getVuexAlias('zonas.index'), params).then(res => {
            zonas.value = res.data
            if (place_id) {
                getZonasAnexas(place_id)
            } else {
                loading.value = false
            }
        }).catch(() => {
            loading.value = false
        })
    }

    function volver() {
        zona.value = null
        viewMode.value = 'region'
    }

    function irAZona(paso, z) {
        zona.value = z
        viewMode.value = 'butacas'
    }

    function getZonasAnexas(place_id) {
        const params = {
            filters: {},
            lista_id: store.getters.getListaId,
            recinto_id: place_id
        }

        store.dispatch(config.getVuexAlias('back.abonos.taquilla.regiones-anexas'), params).then(res => {
            zonas.value = zonas.value.concat(res.data.data)
            loading.value = false
        }).catch(() => {
            loading.value = false
        })
    }

    function getSecciones() {
        loading.value = true
        store.dispatch(config.getVuexAlias('back.abonos.taquilla.recinto.secciones'), {
            filters: {},
            recinto_id: place.value.id,
            lista_id: listaId.value
        }).then(res => {
            secciones.value = res.data.data
            loading.value = false
        }).catch(() => {
            loading.value = false
        })
    }

    function seleccionarSeccion(seccion) {
        breadcrumbs.value.push({
            name: seccion.name,
            id: seccion.id,
            tiene_secciones: seccion.tiene_secciones
        })
        cargando_zonas.value = true
        zonas.value = []
        seccion_seleccionada.value = seccion
        getRegionesDeSeccion(seccion)
    }

    function getRegionesDeSeccion(seccion) {
        cargando_zonas.value = true
        const params = {
            filters: {},
            seccion_id: seccion.id,
            recinto_id: place.value.id,
            lista_id: listaId.value
        }

        store.dispatch(config.getVuexAlias('back.abonos.taquilla.recinto.secciones.regiones'), params).then(res => {
            if (!seccion.tiene_secciones) {
                zonas.value = res.data
            } else {
                secciones.value = res.data.data
            }
        }).finally(() => {
            cargando_zonas.value = false
        })
    }

    function volverSeccion() {
        viewMode.value = 'seccion'
        if (breadcrumbs.value.length <= 1) {
            resetSecciones()
            return
        }
        const index = breadcrumbs.value.length - 2
        irABreadcrumb(breadcrumbs.value[index], index)
    }

    function irABreadcrumb(item, index) {
        if (item.name === 'Inicio') {
            resetSecciones()
        } else {
            breadcrumbs.value.splice(index)
            breadcrumbs.value = [...breadcrumbs.value]
            seleccionarSeccion(item)
        }
    }

    function resetSecciones() {
        breadcrumbs.value = [{ name: 'Inicio' }]
        seccion_seleccionada.value = null
        zonas.value = []
        viewMode.value = 'seccion'
        getSecciones()
    }

    function seleccionarZonaFinal(z) {
        zona.value = z
        viewMode.value = 'butacas'
    }

    onMounted(() => {
        if (place.value.tipo_proceso_taquilla === 2) {
            viewMode.value = 'seccion'
            breadcrumbs.value = [{ name: 'Inicio' }]
            getSecciones()
        } else {
            getZonas(place.value.id)
        }
    })
</script>
